import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountSelectionService, AsinService } from "@front/m19-services";
import { IButtonDirective, ITooltipDirective, ToasterService, IIconComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-catalog-upload",
  templateUrl: "./catalog-upload.component.html",
  styleUrls: ["./catalog-upload.component.scss"],
  imports: [TranslocoDirective, IButtonDirective, ITooltipDirective, RouterLink, IIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CatalogUploadComponent {
  private asinService = inject(AsinService);
  private accountSelection = inject(AccountSelectionService);
  private toasterService = inject(ToasterService);

  errors: string[] = [];

  readonly accountMarketplace = toSignal(this.accountSelection.singleAccountMarketplaceSelection$);

  readonly isReadOnly = toSignal(this.accountSelection.readOnlyMode$, { initialValue: false });

  catalogPage = "/product-center/catalog";

  addAsinToCatalog(inputAsins: string) {
    const asinsList = this.asinService.parseAsinsListFromString(inputAsins);
    const newAsinsList = asinsList.asins;
    this.errors = [...asinsList.errors.invalidAsins, ...asinsList.errors.duplicateAsins];

    if (newAsinsList.length == 0) {
      this.toasterService.error(`No asins to add to catalog`, "Catalog update");
      return;
    }
    const accountMarketplace = this.accountMarketplace()!;
    this.asinService.addAsins(accountMarketplace.accountId, accountMarketplace.marketplace, newAsinsList).subscribe(
      () => {
        this.toasterService.success(`Successfully added ASINs to catalog`, "Catalog update");
        this.asinService.getCatalog(accountMarketplace.accountId, accountMarketplace.marketplace, true);
      },
      () => {
        this.toasterService.error(`Error adding ASINs to catalog`, "Catalog update");
      },
    );
  }
}
